import { __assign, __rest } from "tslib";
import React from 'react';
import VeltVideoPlayerControlsTranscriptionIconWireframe from './VeltVideoPlayerControlsTranscriptionIconWireframe/VeltVideoPlayerControlsTranscriptionIconWireframe';
import VeltVideoPlayerControlsTranscriptionTooltipWireframe from './VeltVideoPlayerControlsTranscriptionTooltipWireframe/VeltVideoPlayerControlsTranscriptionTooltipWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltVideoPlayerControlsTranscriptionButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-transcription-button-wireframe", __assign({}, transformedProps), children));
};
VeltVideoPlayerControlsTranscriptionButtonWireframe.Icon = VeltVideoPlayerControlsTranscriptionIconWireframe;
VeltVideoPlayerControlsTranscriptionButtonWireframe.Tooltip = VeltVideoPlayerControlsTranscriptionTooltipWireframe;
export default VeltVideoPlayerControlsTranscriptionButtonWireframe;
